/**
 * Sons de l'ecran de vente (design 4.3 et 7), par Web Audio : aucun fichier a
 * mettre en cache, rien a telecharger hors ligne.
 *   - scan reussi : bip court et aigu ;
 *   - code inconnu : bip grave, plus long. On ne peut pas le couper (design 7).
 * Le volume reglable est hors du perimetre de la PR 1.5a.
 *
 * Sans Web Audio (jsdom, navigateur ancien) : rien ne joue, rien ne casse.
 */

export const SONS = Object.freeze({
    SCAN_OK: Object.freeze({ nom: 'SCAN_OK', frequence: 1760, dureeMs: 70, volume: 0.15 }),
    CODE_INCONNU: Object.freeze({ nom: 'CODE_INCONNU', frequence: 220, dureeMs: 350, volume: 0.35 }),
});

let contexte = null;

function audioContext() {
    const Ctor = globalThis.AudioContext || globalThis.webkitAudioContext;
    if (!Ctor) return null;
    if (!contexte) contexte = new Ctor();
    return contexte;
}

/**
 * Joue un son de SONS. Ne leve jamais d'erreur : un son qui ne joue pas ne
 * doit pas empecher la vente.
 */
export function jouerSon(son) {
    try {
        const ctx = audioContext();
        if (!ctx) return false;
        if (ctx.state === 'suspended' && typeof ctx.resume === 'function') ctx.resume().catch(() => {});
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = son === SONS.CODE_INCONNU ? 'square' : 'sine';
        osc.frequency.value = son.frequence;
        gain.gain.value = son.volume;
        osc.connect(gain);
        gain.connect(ctx.destination);
        const t = ctx.currentTime;
        osc.start(t);
        osc.stop(t + son.dureeMs / 1000);
        return true;
    } catch (_error) {
        return false;
    }
}
